import { Injectable } from '@angular/core';
import { CanActivateFn, CanMatchFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { Auth } from '@angular/fire/auth';
import { authState } from 'rxfire/auth';
import { map, take } from 'rxjs/operators';

export const redirectIfAuthenticatedGuard: CanActivateFn = () => {
  const auth = inject(Auth);
  const router = inject(Router);

  return authState(auth).pipe(
    take(1),
    map(user => {
      if (user) {
        if (user) {
          // Esto pasa si estoy atenticado, si lo estoy me manda al dashboard
          router.navigate(['/dashboard']);
        } else {
          // Si no lo estuviese, me manda al custom register
          router.navigate(['/custom-register']);
        }
        return false;
      }
      return true;
    })
  );
};
